import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=0fe317f0&scoped=true&"
import script from "./AddType.vue?vue&type=script&lang=js&"
export * from "./AddType.vue?vue&type=script&lang=js&"
import style0 from "./AddType.vue?vue&type=style&index=0&id=0fe317f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe317f0",
  null
  
)

export default component.exports